var path = 'batch/metadataRestore/info/metadataRestoreInfo.tpl.html';
var html = "<react-component name='metadata-restore-info' />\n";
window.angular.module('ng').run(['$templateCache', function(c) { c.put(path, html) }]);
module.exports = path;